<!--
 * @Description: 车主币抽奖
 * @Author: yl
 * @Date: 2021-05-28 17:44:27
 * @LastEditTime: 2021-06-17 17:45:23
 * @LastEditors: yl
-->
<template>
    <div class="topbar-container LotteryIntegral">
        <div class="img-header bg-100 header"></div>
        <div class="img-machinetop bg-100 machine">
            <div class="content bv bc">
                <!-- 抽奖次数 -->
                <div class="lotteryTime bh bc">
                    <span class="label">剩余抽奖次数：<span class="num" v-html="numberOfLuckyDraw"></span>&nbsp;次</span>
                </div>
                <!-- 跑马灯2 -->
                <div class="lightArea2">
                    <div class="line1 bh bbetween">
                        <light2 v-for="({}, i) in 16" :key="i" :vertical='false' :isLottery='isLottery1' :number='i'>
                        </light2>
                    </div>
                    <div class="line2 bc bbetween">
                        <light2 v-for="({}, i) in 7" :key="i" :vertical='true' :isLottery='isLottery1' :number='i'>
                        </light2>
                    </div>
                    <div class="line3 bc bbetween">
                        <light2 v-for="({}, i) in 7" :key="i" :vertical='true' :isLottery='isLottery1' :number='i'>
                        </light2>
                    </div>
                    <div class="line4 bh bbetween">
                        <light2 v-for="({}, i) in 16" :key="i" :vertical='false' :isLottery='isLottery1' :number='i'>
                        </light2>
                    </div>
                </div>
                <van-grid class="grid" :column-num="4" :border="false">
                    <gridItem :isLottery="isLottery1" :resNum="res[0]"></gridItem>
                    <gridItem :isLottery="isLottery2" :resNum="res[1]"></gridItem>
                    <gridItem :isLottery="isLottery3" :resNum="res[2]"></gridItem>
                    <gridItem :isLottery="isLottery4" :resNum="res[3]"></gridItem>
                </van-grid>
                <!-- 温馨提示 -->
                <div class="tipArea bc bv">
                    <div class="img-tipBg bg-100 tip bc bv">
                        <span>温馨提示：{{tipsText}}
                            <span class="btn" v-if="!info || info.numberOfChange > 0" @click="isToSubmitInfo = true"
                                v-html="info && info.idCard ? '点击修改': '点击完善'"></span>
                        </span>
                    </div>
                </div>
            </div>
            <!-- 跑马灯 -->
            <div class="lightArea bh bbetween">
                <light v-for="({}, i) in 7" :key="i" :isLottery='isLottery1' :number='i'></light>
            </div>
            <!-- 按钮 -->
            <div class="btnArea">
                <div class="btn" v-lazy:background-image="require('@/assets/imges/lottery/btnClicked.png')"></div>
                <div @click="toLottery" class="btn_unclicked"
                    v-lazy:background-image="require('@/assets/imges/lottery/btn.png')"></div>
            </div>
        </div>
        <!-- 活动规则 -->
        <div class="rulesArea img-machinebottom bg-100">
            <rules></rules>
        </div>
        <lotterySuccess :dialog.sync='isLotterySuccess' :num="res.join('')"></lotterySuccess>
        <submitInfo :dialog.sync="isToSubmitInfo" @getInfo='getUserInfo' :data='info'></submitInfo>
    </div>
</template>

<script>
import util from '@/utils/index'
import gridItem from "./components/gridItem";
import light from "./components/light";
import light2 from "./components/light2";
import rules from "./components/rules";
import lotterySuccess from "./components/lotterySuccess";
import submitInfo from "./components/submitInfo";
import { getUserInfo, Lottery } from "@/api/lottery";
export default {
    components: { gridItem, light, light2, rules, lotterySuccess, submitInfo },
    name: "LotteryIntegral",
    data() {
        return {
            images: [],
            res: [null, null, null, null],
            isLottery1: false,
            isLottery2: false,
            isLottery3: false,
            isLottery4: false,
            isToSubmitInfo: false,
            isLotterySuccess: false,
            info: null,
            tipsText: '需要完善信息才能抽奖，请'
        };
    },
    computed: {
        numberOfLuckyDraw() {
            if (this.info) return this.info.numberOfLuckyDraw
            return 0
        }
    },
    methods: {
        // 开始抽奖
        toLottery() {
            if (!this.info.idCard) {
                this.toast.fail("请先完善信息");
                return
            }
            if (!this.info.numberOfLuckyDraw) return;
            util.limiting(this.lotterying, null, 5000)
        },
        lotterying() {
            // 开始抽奖动画
            this.res = [0, 0, 0, 0];
            this.isLottery1 = true;
            setTimeout(() => {
                this.isLottery2 = true;
            }, 100);
            setTimeout(() => {
                this.isLottery3 = true;
            }, 200);
            setTimeout(() => {
                this.isLottery4 = true;
            }, 300);

            const params = {
                idCard: this.info.idCard,
                telephone: this.info.telephone,
                H5Authorization: this.$store.state.h5authorization
            }
            Lottery(params).then(res => {
                // console.log(res)
                const { code, data } = res
                const { carCoin, numberOfLuckyDraw } = data
                if (code === 1) {
                    setTimeout(() => {
                        this.isLottery1 = false;
                        this.isLottery2 = false;
                        this.isLottery3 = false;
                        this.isLottery4 = false;
                        // 获取结果
                        this.res[0] = parseInt(carCoin / 1000);
                        this.res[1] = parseInt(carCoin / 100) % 10;
                        this.res[2] = parseInt(carCoin / 10) % 10;
                        this.res[3] = carCoin % 10;
                        this.info['numberOfLuckyDraw'] = numberOfLuckyDraw || 0
                        if (carCoin > 0) {
                            setTimeout(() => {
                                this.isLotterySuccess = true
                            }, 1000);
                        } else {
                            this.toast.fail("很遗憾，这次暂未获得任何奖品！");
                        }
                    }, 3000);
                }
            })
        },
        // 获取用户信息
        getUserInfo(val) {
            // console.log(val)
            this.info = val
            const { numberOfChange } = val
            if (numberOfChange > 0) this.tipsText = `最多可修改${numberOfChange}次信息，请`
            else this.tipsText = `最多可修改0次信息，不可修改`
        },
        // 预加载图片
        initImg() {
            const arr = [
                require("@/assets/imges/lottery/header.png"),
                require("@/assets/imges/lottery/machinetop.png"),
                require("@/assets/imges/lottery/machinebottom.png"),
                require("@/assets/imges/lottery/bg.png"),
                require("@/assets/imges/lottery/0.png"),
                require("@/assets/imges/lottery/1.png"),
                require("@/assets/imges/lottery/2.png"),
                require("@/assets/imges/lottery/3.png"),
                require("@/assets/imges/lottery/4.png"),
                require("@/assets/imges/lottery/5.png"),
                require("@/assets/imges/lottery/6.png"),
                require("@/assets/imges/lottery/7.png"),
                require("@/assets/imges/lottery/8.png"),
                require("@/assets/imges/lottery/9.png"),
                require("@/assets/imges/lottery/prize.png"),
                require("@/assets/imges/lottery/btn.png"),
                require("@/assets/imges/lottery/btnClicked.png"),
                require("@/assets/imges/lottery/tipBg.png"),
                require("@/assets/imges/lottery/unlight.png"),
                require("@/assets/imges/lottery/light.png"),
                require("@/assets/imges/lottery/unlight2.png"),
                require("@/assets/imges/lottery/light2.png")
            ];

            for (let i = 0; i < arr.length; i++) {
                this.images[i] = new Image();
                this.images[i].src = arr[i];
            }
        }
    },
    async mounted() {
        const me = this
        await getUserInfo({ H5Authorization: me.$store.state.h5authorization }).then(res => {
            const { data } = res
            me.info = data
            if (!data) {
                me.info = { numberOfChange: 3, numberOfLuckyDraw: 0 }
            }
            if (data && data.idCard) {
                const { numberOfChange } = data
                if (numberOfChange > 0) me.tipsText = `最多可修改${numberOfChange}次信息，请`
                else me.tipsText = `最多可修改0次信息，不可修改`
            }
        })
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.initImg();
        });
    }
};
</script>

<style scoped lang="scss">
@import "./Integral.scss";
</style>